import React, { Component, useState, useRef } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover,Overlay } from 'react-bootstrap'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import '../../css/AdvanceDeleteButtonTable.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/HomeMini.css';
class AdvanceTableWithoutSearch extends React.Component {
    constructor(props) {
        super(props);
     
        
        this.dt = React.createRef();


        this.state = {
            Id:'',
            deleteProductDialog: true,
            globalSearchBox: '',
            data: this.props.data,
            columns: this.props.columns,
            datakeyName:this.props.datakeyName,
            PageSize:10,
            deletedObject:[],
        };

        this.onChange = this.onChange.bind(this);
        this.exportCSV=this.exportCSV.bind(this);
        this.saveAsExcelFile=this.saveAsExcelFile.bind(this);
        this.exportExcel=this.exportExcel.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.confirmDeleteProduct=this.confirmDeleteProduct.bind(this);
        this.hideDeleteProductDialog=this.hideDeleteProductDialog.bind(this);
        this.sendDeleteObject=this.sendDeleteObject.bind(this);
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data})
    }

    onChange(e) {
        console.log(e.target.value);
        this.setState(
            { [e.target.name]: e.target.value }
        )

    }
    
    exportCSV = () => {
         this.dt.current.exportCSV({ });
    }

    exportPdf = () => {
        const exportColumns = this.state.columns.map(col => ({ title: col.HeaderText, dataKey: col.MappingColomn }));
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, this.state.data);
                doc.save('ExportedFile.pdf');
            })
        })
    }

    exportExcel = () => {
         
        import('xlsx').then(xlsx => {
            let ws = xlsx.utils.json_to_sheet(this.state.data);
            // const worksheet = xlsx.utils.json_to_sheet(this.dt);
            const worksheet = xlsx.utils.json_to_sheet(this.state.data);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, 'ExportedFile');
          }
        );
    }

    saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    actionBodyTemplate(rowData) {
        
        return (
            <React.Fragment>
                    <a onClick={() => this.confirmDeleteProduct(rowData)}>                      
                        <FeatherIcon  icon="trash-2" size="20" />
                    </a> 
               
            </React.Fragment>
        );
    }

    async confirmDeleteProduct(Id) {
        
        
        console.log("Deleted Object");
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to undo this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it'
          }).then((result) => {
            if (result.isConfirmed) {
               this.setState({deletedObject:Id});
              this.sendDeleteObject();

            //   Swal.fire(
            //     'Deleted!',
            //     'Your file has been deleted.'+Id.value,
            //     'success'
            //   )
            }
          })
    }
    hideDeleteProductDialog() {
        this.setState({ deleteProductDialog: false });
    }

    sendDeleteObject = () => {
        this.props.parentDeletedObjectCallback(this.state.deletedObject);
        } 
    

    render() {
       
        return (
                <>
               
                       <Toast ref={(el) => this.toast = el} />
                        <div className="text-right ">
                           
                           {/* <input style={{display:"none"}} type="text" className="pb-2 form-control col-sm-4 col-12 pull-right" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.onChange} /> */}
                        </div>
                        
                        <DataTable dataKey={this.state.datakeyName} ref={this.dt} class="Table" value={this.state.data} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} >
                            {
                                this.state.columns.map(
                                    (item, index) => 
                                    // (
                                         
                                    //      <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>
                                    

                                    //      )
                                    {
                                        {console.log("item.MappingColomn",item.MappingColomn)}
                                        if (item.MappingColomn !== 'id') {
                                          return <Column key={index} field={item.MappingColomn} header={item.HeaderText} sortable></Column>;
                                        } else {
                                          return null; // Exclude the "Id" field from rendering
                                        }
                                    }
                                    )
                                    
                            }
                            <Column body={this.actionBodyTemplate}></Column>
                        </DataTable>
                </>
            
        );
    }
}

export default AdvanceTableWithoutSearch;


